import { Vue } from 'vue-property-decorator';
import VueI18n from 'vue-i18n';
import de from './de.json';
Vue.use(VueI18n);
Vue.config.productionTip = false;
var messages = {
    de: de,
};
export var i18n = new VueI18n({
    locale: 'de',
    messages: messages,
    silentTranslationWarn: true,
});
